"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const core_1 = require("@angular/core");
const common_1 = require("../../../@inax/common");
const logger_1 = require("../../../@inax/logger");
const translate_1 = require("../../../@inax/translate");
const domain_1 = require("./domain");
//TODO:Test if it is better to use pipes for translation
let InaxMotionTextsService = class InaxMotionTextsService {
    constructor(_logger, _translate, _configuration) {
        this._logger = _logger;
        this._translate = _translate;
        this._configuration = _configuration;
        this._tableName = "Motions";
        this._tableQuery = "BlockNum = {}";
        this._defaultLanguage = this._configuration.DefaultLanguage;
    }
    getSymbolicName(motion) {
        let textList = this.getTextTable(motion);
        return textList.get(motion.Name);
    }
    getDirection1Text(motion) {
        let textList = this.getTextTable(motion);
        return textList.get(motion.Direction1Text);
    }
    getDirection2Text(motion) {
        let textList = this.getTextTable(motion);
        return textList.get(motion.Direction2Text);
    }
    getFinalPositionText(motion, finalPosition) {
        let textList = this.getTextTable(motion);
        return this.getPositionTextsByUsageType(finalPosition, textList);
    }
    getTextTable(motion) {
        if (motion.Texts == null || !motion.Texts.hasLanguage(this._language)) {
            this.loadTextsForMotion(motion);
            return motion.Texts.Language[this._defaultLanguage];
        }
        return motion.Texts.Language[this._language];
    }
    loadTextsForMotion(motion) {
        this.loadDefaultTexts(motion);
        if (this._language != this._defaultLanguage)
            this.loadLanguageTexts(motion);
    }
    getPositionTextsByUsageType(finalPosition, texts) {
        switch (finalPosition.UsageType) {
            case 0:
                return "";
            case 1:
                return texts.get(finalPosition.Name);
            case 2: //auto text
            case 3:
                return texts.get(finalPosition.SymbolicAddress);
            case 4: //editable bit
            case 5:
                return texts.get(finalPosition.Name);
        }
    }
    loadLanguageTexts(motion) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!motion.Texts.hasLanguage(this._language))
                motion.Texts.Language[this._language] = new domain_1.LanguageEntryList();
            {
                let toTranslate = motion.Texts.Language[this._defaultLanguage].keys;
                let translated = yield this._translate.tranlsateManyOnline(toTranslate, this._defaultLanguage, this._language).toPromise();
                let txt = motion.Texts.Language[this._language];
                for (let i = 0; i < translated.length; i++) {
                    txt.add(toTranslate[i], translated[i]);
                }
            }
        });
    }
    loadDefaultTexts(motion) {
        if (motion.Texts == null) {
            motion.Texts = new domain_1.MotionTextTable();
            let txt = new domain_1.LanguageEntryList();
            txt.add(motion.Name, motion.Name);
            txt.add(motion.Direction1Text, motion.Direction1Text);
            txt.add(motion.Direction2Text, motion.Direction2Text);
            motion.FinalPositions.forEach(finalPosition => {
                if (txt.get(finalPosition.SymbolicAddress) == null) {
                    switch (finalPosition.UsageType) {
                        case 0:
                            break;
                        case 1:
                            if (finalPosition.Name != null)
                                txt.add(finalPosition.Name, finalPosition.Name);
                            break;
                        case 2: //auto text
                        case 3:
                            if (finalPosition.SymbolicAddress != null)
                                txt.add(finalPosition.SymbolicAddress, finalPosition.SymbolicAddress);
                            break;
                        case 4: //editable bit
                        case 5:
                            if (finalPosition.Name != null)
                                txt.add(finalPosition.Name, finalPosition.Name);
                            break;
                    }
                }
            });
            motion.Texts.Language[this._defaultLanguage] = txt;
        }
    }
};
InaxMotionTextsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [logger_1.InaxLoggerService,
        translate_1.InaxTranslateService,
        common_1.InaxConfiguration])
], InaxMotionTextsService);
exports.InaxMotionTextsService = InaxMotionTextsService;
